/** @format */

import { Button } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../store/hook";
import { useNavigate } from "react-router-dom";
import { setUserRole } from "../../../store/role";
import * as RoleSelector from "src/store/role/selector";
//NOT USING THIS PAGE
const LandingPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClick = (role) => {
    console.log("Selected role:", role);
    dispatch(setUserRole(role));
    navigate("/auth/sign-in");
  };

  return (
    <>
      <Button onClick={() => handleClick("user")}>User</Button>
      <Button onClick={() => handleClick("employer")}>Employer</Button>
    </>
  );
};

export default LandingPage;
